/**
 * Which surface a file entered the app from, for the API's
 * `asset_upload_result` event (RFC-1577). The console sends it as the
 * `X-Upload-Source` header on the upload request.
 *
 * Canvas uploads are created as upload nodes that start their own upload from
 * `initialFile`, far from the surface that produced the file. Rather than
 * thread an analytics-only field through generated node data, the creating
 * surface tags the File here and the node's upload reads the tag back. Keyed
 * weakly: a tag never outlives its File.
 */
import type { UploadSource } from './generated/analyticsEvents'

const sources = new WeakMap<File, UploadSource>()

/** Record that `file` came from `source`; returns the file for chaining. */
export function tagUploadSource(file: File, source: UploadSource): File {
  sources.set(file, source)
  return file
}

/** The surface `file` was tagged with, if any. */
export function uploadSourceOf(file: File): UploadSource | undefined {
  return sources.get(file)
}
